export class Selection {
  constructor () {
    this.data = new Map()
    this.direction = ''
  }
  uniqueKeyFormat (rowIndex, columnIndex) {
    return rowIndex + '_' + columnIndex
  }
  add ({val, rowIndex, columnIndex} = {}) {
    const uniqueKey = this.uniqueKeyFormat(rowIndex, columnIndex)
    this.data.set(uniqueKey, {rowIndex, columnIndex, val})
  }
  has ({rowIndex, columnIndex} = {}) {
    const uniqueKey = this.uniqueKeyFormat(rowIndex, columnIndex)
    return this.data.has(uniqueKey)
  }
  delete ({rowIndex, columnIndex} = {}) {
    const uniqueKey = this.uniqueKeyFormat(rowIndex, columnIndex)
    this.data.delete(uniqueKey)
  }
  clear() {
    this.data.clear()
  }
  getSelected () {
    const arr = Array.from(this.data.values()).map(r => r.val)
    const direction = this.direction
    return direction === 'vertical' ? arr.join('\n') : arr.join(' ')
  }
  isGridCross () {
    const values = Array.from(this.data.values())
    const rowIndexs = values.map(c => c.rowIndex)
    const eachEqualInRows = rowIndexs.every(v => v === rowIndexs[0])

    const columnIndexs = values.map(c => c.columnIndex)
    const eachEqualInCols = columnIndexs.every(v => v === columnIndexs[0])

    this.direction = eachEqualInRows ? 'horizontal' : 'vertical'
    if (!eachEqualInRows && !eachEqualInCols) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/public/plugins/copy-cells/grid-selection.js